import React from "react"
import { injectIntl } from "react-intl"
import ImgSrcSet from "./ImgSrcSet"
import {
  createSrcSetFromCollection,
  getImageType,
  getPlaceholder
} from "../../scripts/resource"
import settingsMessages from "../../messages/settings"

class CollectionImage extends React.Component {
  getImageData = (image, resource) => {
    if (!image) {
      // Images may be null
      const { images } = this.props
      const src = images && images["medium"].url

      if (src) {
        return {
          src,
          srcSet: createSrcSetFromCollection(resource, getImageType(resource))
        }
      }
    }

    return image
  }

  render() {
    const { images, intl, ...props } = this.props

    const image = [images].reduce(this.getImageData, null) || {
      src: getPlaceholder(
        "collection",
        intl.formatMessage(settingsMessages.authenticAccountId)
      ).small,
      srcSet: []
    }

    return (
      <ImgSrcSet
        {...props}
        src={image.src}
        srcSet={image.srcSet}
        imgAlt="collection image"
      />
    )
  }
}

export default injectIntl(CollectionImage)



// WEBPACK FOOTER //
// ./webapp/components/elements/CollectionImage.js